import { Action } from 'redux';
import { OrderedMap } from 'immutable';

import { Currency } from '../../models/Hotels/Currency';

import { REQUEST_CURRENCIES, RESPONSE_CURRENCIES, ERROR_CURRENCIES, SET_CURRENCY } from '../../actions/Flight/currencies';

export interface FlightCurrenciesState {
    currencies: OrderedMap<number, Currency>;
    loadingCurrencies: boolean;
    errorCurrencies: any;
    currency: Currency;
}

const initialState: FlightCurrenciesState = {
    currency: {} as Currency,
    currencies: OrderedMap<number, Currency>(),
    loadingCurrencies: false,
    errorCurrencies: null
};

export function flightCurrency(state: FlightCurrenciesState = initialState, action: Action) {
    switch (action.type) {
        case REQUEST_CURRENCIES: {
            return {
                ...state,
                currencies: initialState.currencies,
                loadingCurrencies: true,
                errorCurrencies: initialState.errorCurrencies
            };
        }
        case RESPONSE_CURRENCIES: {
            const currencies = ((action as any).response.result as Array<Currency>).reduce((prev, cur) => prev.set(cur.id, cur), initialState.currencies);
            return {
                ...state,
                currencies,
                loadingCurrencies: false
            };
        }
        case ERROR_CURRENCIES: {
            return {
                ...state,
                loadingCurrencies: false,
                errorCurrencies: (action as any).error
            };
        }
        case SET_CURRENCY: {
            return {
                ...state,
                currency: (action as any).currency
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/Flight/currency.ts